const PESOS_CLABE = [3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7, 1, 3, 7];

export function validarCLABE(clabe) {
  if (!clabe) return null;
  const digits = clabe.replace(/\s/g, '');
  if (!/^\d{18}$/.test(digits)) return { valida: false, mensaje: 'Debe tener 18 dígitos' };
  const suma = PESOS_CLABE.reduce((acc, peso, i) => acc + (parseInt(digits[i]) * peso) % 10, 0);
  const digitoControl = (10 - (suma % 10)) % 10;
  const valida = digitoControl === parseInt(digits[17]);
  return { valida, mensaje: valida ? 'CLABE válida' : 'Dígito verificador incorrecto' };
}

// Fecha de HOY como YYYY-MM-DD en la zona horaria del navegador.
//
// NO usar `new Date().toISOString().split('T')[0]`: toISOString convierte a UTC,
// así que en México (UTC−6) todo lo capturado desde las 18:00 salía fechado al
// DÍA SIGUIENTE. 'en-CA' es el truco: es el locale cuyo formato de fecha corto
// ya es YYYY-MM-DD, y toLocaleDateString respeta la hora local.
export function hoyISO() {
  return new Date().toLocaleDateString('en-CA');
}

// Un Date cualquiera a YYYY-MM-DD local, con el mismo criterio que hoyISO.
export function fechaISO(d) {
  const f = d instanceof Date ? d : new Date(d);
  return isNaN(f) ? '' : f.toLocaleDateString('en-CA');
}
